var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){_vm.isModal = true}}},[_vm._t("default")],2),_c('base-modal',{attrs:{"is-base-modal":_vm.isModal,"width":600},on:{"close":_vm.closeModal}},[_c('v-card',{attrs:{"flat":""}},[_vm._t("content")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }